import $ from 'jquery';

class VehiclesSearchForm {
    constructor(el) {
        this.$el = $(el);

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        if(typeof cha.vehiclesSearchFormData !== 'undefined') {
            this.formFields = {
                carrosseries: {
                    $el: this.$el.find('.vehicles-search-form__carrosserie-select'),
                    placeholder: 'Catégorie',
                    options: cha.vehiclesSearchFormData?.carrosseries?.all
                },
                marques: {
                    $el: this.$el.find('.vehicles-search-form__marque-select'),
                    placeholder: 'Marque',
                    options: cha.vehiclesSearchFormData?.marques?.all
                },
                modeles: {
                    $el: this.$el.find('.vehicles-search-form__modele-select'),
                    placeholder: 'Modèle',
                    options: cha.vehiclesSearchFormData?.modeles?.all
                }
            };
            this.$form = this.$el.find('form');
            
            if(this.$form.length && this.formFields.carrosseries.$el.length && this.formFields.marques.$el.length && this.formFields.modeles.$el.length) {
                this._initForm();
                this._bindEvents();
            }

            // Setting colorbox settings
            let cboxOptions = {
                width: '95%',
                height: '95%',
                inline: true,
                fixed: true,
                maxWidth: '960px',
                maxHeight: '960px',
            }

            // Initilisation de colorbox
            $(".filters-home").colorbox(cboxOptions); 

            // Fonction permettant de resize colorbox 
            $(window).resize(function() {
                $.colorbox.resize({
                    width: window.innerWidth > parseInt(cboxOptions.maxWidth) ? cboxOptions.maxWidth : cboxOptions.width,
                    height: window.innerHeight > parseInt(cboxOptions.maxHeight) ? cboxOptions.maxHeight : cboxOptions.height
                });
            });
        }
    }

    _bindEvents() {
        this.onCarrosserieChangeFn = this._onCarrosserieChange.bind(this);
        this.onMarqueChangeFn = this._onMarqueChange.bind(this);

        this.formFields.carrosseries.$el.on('change', this.onCarrosserieChangeFn);
        this.formFields.marques.$el.on('change', this.onMarqueChangeFn);
    }

    _initForm() {
        Object.keys(this.formFields).forEach((property) => {
            let options = `<option value="all" selected>${this.formFields[property].placeholder}</option>`;
            this.formFields[property].options.forEach((value) => {
                options += '<option value="' + value + '">' + value.charAt(0).toUpperCase() + value.toLowerCase().slice(1) + '</option>'
            });
            this.formFields[property].$el.append(options);    
        });
    }

    _onCarrosserieChange() {
        const carrosserie = this.formFields.carrosseries.$el.val();
        const prevBrandValue = this.formFields.marques.$el.val();

        this.formFields.marques.$el.empty();
        
        const prevBrandValueIndex = cha.vehiclesSearchFormData.marques[carrosserie].indexOf(prevBrandValue);
        let marquesOptions = `<option value="all" selected>${this.formFields.marques.placeholder}</option>`;
        
        if(cha.vehiclesSearchFormData.marques[carrosserie] && cha.vehiclesSearchFormData.marques[carrosserie].length) {
            cha.vehiclesSearchFormData.marques[carrosserie].forEach((value) => {
                marquesOptions += '<option value="' + value + '">' + value.charAt(0).toUpperCase() + value.toLowerCase().slice(1) + '</option>'
            });
        }

        this.formFields.marques.$el.append(marquesOptions);

        if(prevBrandValueIndex !== -1) {
            this.formFields.marques.$el[0].selectedIndex = prevBrandValueIndex + 1;            
        }

        this.formFields.marques.$el.trigger('change');
    }

    _onMarqueChange() {
        const carrosserie = this.formFields.carrosseries.$el.val();
        const marque = this.formFields.marques.$el.val();
        const prevModelValue = this.formFields.modeles.$el.val();
        let key = '';

        this.formFields.modeles.$el.empty();

        if(carrosserie !== 'all' && marque !== 'all') {
            key = carrosserie + '__' + marque;
        }
        else if(carrosserie === 'all' && marque !== 'all') {
            key = marque;
        }
        else if(carrosserie !== 'all' && marque === 'all') {
            key = carrosserie;
        }
        else if(carrosserie == 'all' && marque == 'all') {
            key = 'all';
        }
    
        const prevModelValueIndex = cha.vehiclesSearchFormData.modeles[key].indexOf(prevModelValue);
        let modelesOptions = `<option value="all" selected>${this.formFields.modeles.placeholder}</option>`;

        if(key && cha.vehiclesSearchFormData.modeles[key] && cha.vehiclesSearchFormData.modeles[key].length) {
            cha.vehiclesSearchFormData.modeles[key].forEach((value) => {
                modelesOptions += '<option value="' + value + '">' + value.charAt(0).toUpperCase() + value.toLowerCase().slice(1) + '</option>'
            });
        }
        
        this.formFields.modeles.$el.append(modelesOptions);

        if(prevModelValueIndex !== -1) {
            this.formFields.modeles.$el[0].selectedIndex = prevModelValueIndex + 1;            
        }

        this.formFields.modeles.$el.trigger('change');
    }
}

export default VehiclesSearchForm;

new VehiclesSearchForm(document.querySelector('.vehicles-search-form'));